'use client';

import { useEffect, useState } from 'react';
import MarqueeBuilder from './marquee-builder';

export default function NavbarScrollWrapper({ children }: { children: React.ReactNode }) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed left-0 right-0 top-0 z-50 flex ${!isScrolled ? 'h-[calc(var(--marquee-banner-height)+var(--navbar-height))]' : 'h-[var(--navbar-height)]'} w-full items-center justify-between p-4 py-5 transition-all duration-300 lg:px-6 ${
        isScrolled ? 'bg-white/70 backdrop-blur-md' : 'bg-white'
      }`}
    >
      <MarqueeBuilder isScrolled={isScrolled} />
      <div
        className={`flex w-full justify-center ${!isScrolled ? 'pt-[calc(var(--marquee-banner-height))]' : ''}`}
      >
        {children}
      </div>
    </nav>
  );
}
